import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SiteHeader } from "@/components/SiteHeader";
import { SiteFooter } from "@/components/SiteFooter";
import { PageHero } from "@/components/PageHero";
import { publicApi, API } from "@/lib/api";
import { IMG } from "@/lib/content";
import { AutoRail } from "@/components/AutoRail";

export const communityImg = (c) => (c.has_photo ? `${API}/public/communities/${c.id}/photo` : c.image || IMG.hero);

export default function Communities() {
  const [list, setList] = useState([]);
  useEffect(() => { publicApi.get("/public/communities").then((r) => setList(r.data)).catch(() => {}); }, []);
  return (
    <div className="min-h-screen bg-[#F8FAFC]" data-testid="communities-page">
      <SiteHeader />
      <PageHero eyebrow="Communities" title="You don't have to do life alone." lead="Find friends who share your season of life, and grow in faith together." img={IMG.hero} />
      <main className="mx-auto max-w-7xl px-5 py-14 lg:px-10">
        {list.length > 0 && <AutoRail section="communities" items={list} gap="gap-6" render={(c, i) => (
          <Link key={c.id} to={`/communities/${c.slug}`} data-testid={`community-card-${c.slug}`}
            className="group block h-full overflow-hidden rounded-3xl border border-slate-200 bg-white transition-transform duration-300 hover:-translate-y-1" style={{ animationDelay: `${i * 80}ms` }}>
            <div className="aspect-[4/3] overflow-hidden"><img src={communityImg(c)} alt={c.name} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" /></div>
            <div className="p-6">
              <h2 className="text-xl font-bold tracking-tight text-[#0A3A6B]">{c.name}</h2>
              <p className="mt-1 text-sm text-slate-500">{c.tagline}</p>
              <span className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-[#1D64B4]">Learn more <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" /></span>
            </div>
          </Link>
        )} />}
      </main>
      <SiteFooter />
    </div>
  );
}
